import { render } from "./view.mobile.vue?vue&type=template&id=1c22eccd&scoped=true&ts=true"
import script from "./view.mobile.vue?vue&type=script&lang=ts"
export * from "./view.mobile.vue?vue&type=script&lang=ts"

import "./view.mobile.vue?vue&type=style&index=0&id=1c22eccd&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c22eccd"]])

export default __exports__